module.exports = __webpack_public_path__ + "media/images/researcher-1ff2e695a2a7fb6ebf06357f0c4a5991.jpg";